var _style, _rect, _g, _g2, _g3, _g4, _path, _g5, _ellipse, _ellipse2, _ellipse3, _ellipse4, _polygon, _polygon2, _path2, _path3, _path4, _polygon3, _polyline, _path5, _path6, _path7, _polygon4, _path8, _g6, _defs, _g7, _polygon5, _g8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostmericaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 591.7 352.2"
    },
    xmlSpace: "preserve",
    viewBox: "71.2 85.6 449.4 181.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:none;fill:#D2D2D2;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#212E4E;}\r\n\t.st4{fill:#1D2B46;}\r\n\t.st5{fill:#A134A1;}\r\n\t.st6{fill:#8461C7;}\r\n\t.st7{fill:#6D65B4;}\r\n\t.st8{fill:#8E3394;}\r\n\t.st9{fill:#4D2982;}\r\n\t.st10{fill:#AF2CA3;}\r\n\t.st11{fill:#FF52D2;}\r\n\t.st12{fill:#FF4CCB;}\r\n\t.st13{fill:#F44CC2;}\r\n\t.st14{fill:#D93DB5;}\r\n\t.st15{fill:#F240C8;}\r\n\t.st16{fill:#B63EAE;}\r\n\t.st17{fill:#DA46B9;}\r\n\t.st18{fill:#742C8D;}\r\n\t.st19{fill:#CF36B9;}\r\n\t.st20{fill:#262557;}\r\n\t.st21{fill:#342070;}\r\n\t.st22{fill:#B3B1DE;}\r\n\t.st23{fill:#813EBE;}\r\n\t.st24{fill:#C059E7;}\r\n\t.st25{fill:#9392BE;}\r\n\t.st26{fill:#F142EF;}\r\n\t.st27{clip-path:url(#SVGID_2_);}\r\n\t.st28{fill:#FFADFC;}\r\n\t.st29{fill:#AB4FDE;}\r\n\t.st30{fill:#9B51D0;}\r\n\t.st31{fill:#9E5AD9;}\r\n\t.st32{fill:#8A4BC9;}\r\n\t.st33{fill:#7A44C5;}\r\n\t.st34{fill:#733BC0;}\r\n\t.st35{fill:#6E35BE;}\r\n\t.st36{fill:#6326B9;}\r\n\t.st37{fill:#5817B4;}\r\n\t.st38{fill:#4902AD;}\r\n\t.st39{fill:#4F1AAB;}\r\n\t.st40{fill:#4007A4;}\r\n\t.st41{fill:#3B009F;}\r\n\t.st42{display:none;fill:#23334B;}\r\n\t.st43{fill:#EC57D3;}\r\n\t.st44{clip-path:url(#SVGID_4_);}\r\n\t.st45{fill:url(#SVGID_5_);}\r\n\t.st46{fill:#B865D6;}\r\n\t.st47{fill:#B064D0;}\r\n\t.st48{fill:#A55FCC;}\r\n\t.st49{fill:#A25BCB;}\r\n\t.st50{fill:#7E4EB0;}\r\n\t.st51{fill:#6C4DAD;}\r\n\t.st52{fill:#594A8E;}\r\n\t.st53{fill:#6651A3;}\r\n\t.st54{fill:#644D95;}\r\n\t.st55{fill:#C7D2E7;}\r\n\t.st56{clip-path:url(#SVGID_7_);}\r\n\t.st57{clip-path:url(#SVGID_9_);}\r\n\t.st58{clip-path:url(#SVGID_11_);}\r\n\t.st59{fill:url(#SVGID_12_);}\r\n\t.st60{clip-path:url(#SVGID_14_);}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 591.7,
    height: 352.2
  })), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M211.3,230c0,0,2.1,8.3,2.5,9.4c0.4,1.1,9.3,14.3,9.3,14.3l151.5-2.4c0,0,9.5-13.2,10.4-13.7    s-0.9-3.7-0.9-3.7L211.3,230z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M216.4,150.3l-3.3-6.1c0,0,15.8-28.6,41.7-38.4c25.9-9.7,44.8-10.2,55.7-8.8c11,1.4,39.8,10.1,56.7,31.5    s25.5,45.5,21.5,68.7c-12.4-13.9-33.2-32.1-33.2-32.1l-109-5.4L216.4,150.3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M295.9,92.9c-54.2,0-98.1,43.9-98.1,98.1c0,20.9,6.5,40.3,17.7,56.2c1.6,2.2,3.2,4.4,4.9,6.5     c1.9,2.2,3.8,4.4,5.9,6.5c2.2,2.3,4.6,4.4,7.1,6.5h8.2c-2.8-2-5.5-4.2-8-6.5c-2.3-2-4.4-4.2-6.5-6.5c-1.9-2.1-3.7-4.2-5.4-6.5     c-11.9-15.6-18.9-35.1-18.9-56.2c0-51.3,41.8-93.1,93.1-93.1c51.3,0,93.1,41.8,93.1,93.1c0,21.1-7,40.6-18.9,56.2     c-1.7,2.2-3.5,4.4-5.4,6.5c-2.1,2.3-4.2,4.4-6.5,6.5c-2.5,2.3-5.2,4.5-8,6.5h8.2c2.5-2,4.8-4.2,7.1-6.5c2-2.1,4-4.2,5.9-6.5     c1.7-2.1,3.4-4.2,4.9-6.5c11.1-15.9,17.7-35.3,17.7-56.2C394,136.8,350,92.9,295.9,92.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M416.6,263.4c0,0.9-0.4,1.7-0.9,2.3c-0.6,0.6-1.4,1-2.3,1h-235c-1.8,0-3.2-1.5-3.2-3.2c0-0.9,0.4-1.7,1-2.3    c0.6-0.6,1.4-0.9,2.3-0.9h235C415.2,260.1,416.6,261.6,416.6,263.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M380.6,253.7c-1.7,2.2-3.4,4.4-5.2,6.5H216.3c-1.8-2.1-3.5-4.2-5.2-6.5H380.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M385,247.2c-1.4,2.2-2.8,4.4-4.4,6.5H211.1c-1.6-2.1-3-4.2-4.4-6.5H385z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "417.6,240.3 419.9,244.9 425,245.7 421.3,249.3 422.2,254.4 417.6,252 413,254.4 413.8,249.3      410.1,245.7 415.3,244.9    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "449.9,240.3 452.2,244.9 457.3,245.7 453.6,249.3 454.5,254.4 449.9,252 445.3,254.4 446.1,249.3      442.4,245.7 447.6,244.9    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "449.9,131.1 452.2,135.8 457.3,136.5 453.6,140.2 454.5,145.3 449.9,142.9 445.3,145.3      446.1,140.2 442.4,136.5 447.6,135.8    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "482.2,240.3 484.5,244.9 489.6,245.7 485.9,249.3 486.8,254.4 482.2,252 477.6,254.4 478.4,249.3      474.7,245.7 479.9,244.9    "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M477.3,160.7c0,2.2-1.8,4-4,4h-69.2c-0.6-2.7-1.4-5.4-2.2-8h71.4C475.5,156.7,477.3,158.5,477.3,160.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M499.8,164.7h-0.2c-2.2,0-4-1.8-4-4s1.8-4,4-4h0.2c2.2,0,4,1.8,4,4S502,164.7,499.8,164.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M487.3,176.2c0,2.2-1.8,4-4,4h-76.6c-0.3-2.7-0.6-5.4-1.1-8h77.7C485.5,172.2,487.3,174,487.3,176.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M477.3,191.7c0,2.2-1.8,4-4,4h-66.2c0.1-1.5,0.1-3.1,0.1-4.6c0-1.1,0-2.2,0-3.4h66.1       C475.5,187.7,477.3,189.4,477.3,191.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M516.6,195.7h-5.5c-2.2,0-4-1.8-4-4s1.8-4,4-4h5.5c2.2,0,4,1.8,4,4S518.8,195.7,516.6,195.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M467.3,207.1c0,2.2-1.8,4-4,4h-57.9c0.5-2.6,0.9-5.3,1.2-8h56.7C465.5,203.1,467.3,204.9,467.3,207.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M493,211.1h-13c-2.2,0-4-1.8-4-4s1.8-4,4-4h13c2.2,0,4,1.8,4,4S495.2,211.1,493,211.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M482.4,222.6c0,2.2-1.8,4-4,4h-77c0.9-2.6,1.7-5.3,2.4-8h74.6C480.6,218.6,482.4,220.4,482.4,222.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st19",
    cx: 492.2,
    cy: 191.7,
    rx: 2.2,
    ry: 4
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "174.2,240.3 171.9,244.9 166.7,245.7 170.4,249.3 169.6,254.4 174.2,252 178.8,254.4 177.9,249.3     181.6,245.7 176.5,244.9   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "141.9,240.3 139.6,244.9 134.4,245.7 138.1,249.3 137.3,254.4 141.9,252 146.5,254.4 145.6,249.3     149.3,245.7 144.2,244.9   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "141.9,131.1 139.6,135.8 134.4,136.5 138.1,140.2 137.3,145.3 141.9,142.9 146.5,145.3 145.6,140.2     149.3,136.5 144.2,135.8   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "109.6,240.3 107.3,244.9 102.1,245.7 105.9,249.3 105,254.4 109.6,252 114.2,254.4 113.3,249.3     117,245.7 111.9,244.9   "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M114.4,160.7c0,2.2,1.8,4,4,4h69.2c0.6-2.7,1.4-5.4,2.2-8h-71.4C116.2,156.7,114.4,158.5,114.4,160.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M91.9,164.7h0.2c2.2,0,4-1.8,4-4s-1.8-4-4-4h-0.2c-2.2,0-4,1.8-4,4S89.7,164.7,91.9,164.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M104.4,176.2c0,2.2,1.8,4,4,4H185c0.3-2.7,0.6-5.4,1.1-8h-77.7C106.2,172.2,104.4,174,104.4,176.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M114.4,191.7c0,2.2,1.8,4,4,4h66.2c-0.1-1.5-0.1-3.1-0.1-4.6c0-1.1,0-2.2,0-3.4h-66.1      C116.2,187.7,114.4,189.4,114.4,191.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M75.2,195.7h5.5c2.2,0,4-1.8,4-4s-1.8-4-4-4h-5.5c-2.2,0-4,1.8-4,4S72.9,195.7,75.2,195.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M124.4,207.1c0,2.2,1.8,4,4,4h57.9c-0.5-2.6-0.9-5.3-1.2-8h-56.7C126.2,203.1,124.4,204.9,124.4,207.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M98.8,211.1h13c2.2,0,4-1.8,4-4s-1.8-4-4-4h-13c-2.2,0-4,1.8-4,4S96.6,211.1,98.8,211.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M109.3,222.6c0,2.2,1.8,4,4,4h77c-0.9-2.6-1.7-5.3-2.4-8h-74.6C111.1,218.6,109.3,220.4,109.3,222.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st20",
    cx: 99.5,
    cy: 191.7,
    rx: 2.2,
    ry: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M295.9,85.6c-58.2,0-105.4,47.2-105.4,105.4c0,20.6,5.9,39.9,16.2,56.2c1.4,2.2,2.8,4.4,4.4,6.5     c1.6,2.2,3.4,4.4,5.2,6.5c1.9,2.2,4,4.4,6.1,6.5h12.1c-2.5-2-4.9-4.2-7.2-6.5c-2.1-2.1-4.1-4.2-6-6.5c-1.8-2.1-3.4-4.2-5-6.5     c-11.3-15.9-17.9-35.3-17.9-56.2c0-53.7,43.7-97.4,97.4-97.4c53.7,0,97.4,43.7,97.4,97.4c0,20.9-6.6,40.3-17.9,56.2     c-1.6,2.2-3.2,4.4-5,6.5c-1.9,2.2-3.9,4.4-6,6.5c-2.3,2.3-4.7,4.4-7.2,6.5h12.1c2.1-2.1,4.2-4.2,6.1-6.5c1.8-2.1,3.5-4.2,5.2-6.5     c1.5-2.1,3-4.2,4.4-6.5c10.3-16.3,16.2-35.5,16.2-56.2C401.2,132.8,354.1,85.6,295.9,85.6z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "st10",
    cx: 172.7,
    cy: 139.2,
    rx: 5.1,
    ry: 4.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st10",
    cx: 419,
    cy: 139.2,
    rx: 5.1,
    ry: 4.3
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M383.1,216.9c7-20.5-9.2-27.7-9.2-27.7s0.7-11.3,0-17.3c-0.7-6-16.4-11.3-16.4-11.3L357,146l-63.5-21.2    l-79.3,30.6l-1,72.5h11.6l19.4,9.4l129.6-3.1c0.4,0,0.8,0,1.2,0c8.2,0,10.6-2.5,10.6-4.8c0-2.4,0.7-5.8,0.7-7.8    S385.9,217.2,383.1,216.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M293.6,124.8L357,146l0.4,14.6c0,0,15.7,5.3,16.4,11.3c0.7,6,0,17.3,0,17.3s16.2,7.2,9.2,27.7    c2.8,0.3,3.3,2.7,3.3,4.8c0,2-0.7,5.4-0.7,7.8c0,2.3-2.4,4.8-10.6,4.8c-0.4,0-0.8,0-1.2,0l-129.6,3.1l-19.4-9.4h-11.6l1-72.5    L293.6,124.8 M293.6,116.8c-1,0-2,0.2-2.9,0.5L211.3,148c-3,1.2-5.1,4.1-5.1,7.4l-1,72.5c0,2.1,0.8,4.2,2.3,5.7    c1.5,1.5,3.6,2.4,5.7,2.4h9.8l17.8,8.6c1.1,0.5,2.3,0.8,3.5,0.8c0.1,0,0.1,0,0.2,0l129.4-3.1c0.4,0,0.8,0,1.2,0    c17.7,0,18.6-10.7,18.6-12.8c0-0.8,0.2-2.1,0.3-3.2c0.2-1.5,0.4-3.1,0.4-4.6c0-3.4-0.9-6-2.2-7.9c2.7-14.3-3.7-23.8-10.1-28.8    c0.1-4.1,0.2-9.9-0.3-13.9c-0.6-5.4-4.8-10-12.8-14.1c-1.3-0.7-2.6-1.3-3.8-1.8l-0.3-9.3c-0.1-3.4-2.3-6.3-5.5-7.4l-63.5-21.2    C295.3,117,294.4,116.8,293.6,116.8L293.6,116.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M293.6,129.1l58.5,19.5l0.3,11.1l0.1,3.5l3.3,1.1c5.9,2,12.2,5.5,13.1,7.3c0.6,5.5,0,16.1,0,16.2l-0.2,3.5     l3.2,1.4c0.5,0.2,11.9,5.6,6.5,21.5l-2.1,6.5l5.2-0.1c0,0.7-0.1,1.8-0.3,2.9c-0.2,1.3-0.3,2.6-0.4,3.8c-0.7,0.3-2.3,0.8-5.6,0.8     c-0.4,0-0.7,0-1.1,0l-0.1,0l-0.1,0l-128.4,3.1l-18.3-8.9l-1-0.5h-1.1h-6.5l0.9-64L293.6,129.1 M293.4,123.8l-79.3,30.6l-1,72.5     h11.6l19.4,9.4l129.6-3.1c0.4,0,0.8,0,1.2,0c8.2,0,10.6-2.5,10.6-4.8c0-2.4,0.7-5.8,0.7-7.8c0-2-0.6-4.5-3.3-4.8     c7-20.5-9.2-27.7-9.2-27.7s0.7-11.3,0-17.3s-16.4-11.3-16.4-11.3l-0.4-14.6L293.4,123.8L293.4,123.8z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 313.6,
    cy: 229,
    rx: 18.5,
    ry: 18.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 310.8,
    cy: 226.6,
    rx: 9.6,
    ry: 10.9
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M303.6,208.2v-6.5c0,0,2.5-4.6,2.9-5s1.6-2.1,4.3-2.1s7.5-0.4,10.1,0c2.6,0.4,6,1.2,7.2,2.1s1.8,1.2,2.3,2.7   c0.5,1.6,1,5.4,1,6.1s0.7,7.1,0.7,7.1h-0.7l-3.2-2.2c0,0-6.1-4.8-7.1-5c-1-0.1-6.1-0.7-6.1-0.7s-4.1,0.3-4.2,0.3   c-0.2,0-1,0.3-1,0.3l-4,1.2L303.6,208.2z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 236.8,
    cy: 232.2,
    r: 15
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 236,
    cy: 232.2,
    rx: 6.4,
    ry: 7.1
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 272.9,
    cy: 232.2,
    rx: 14.3,
    ry: 15
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 356.7,
    cy: 230,
    rx: 15.8,
    ry: 17.2
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 344.5,
    cy: 204.8,
    rx: 5.1,
    ry: 5.9
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 378.3,
    cy: 206.7,
    rx: 3.7,
    ry: 4.9
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "353,209.3 369.2,209.7 369.2,212.8 353.3,212.8  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "369.8,202.7 369.2,205.6 354.6,205.1 354.6,201.2  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M373.8,197.3l-21.9-1.6l-13.2-6.7c0,0,22.2,2.2,27.3,2.8C371.1,192.4,374.1,194,373.8,197.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M303.6,201.7v-32.8l7.2,0l-1.3,1.3c0,0-1.9,18-1.7,18.8s20-2.8,20-2.8l13.1,7.6c0,0-13.4,8.9-4,19   c-4.9-0.2-4.9-0.2-4.9-0.2S325.2,187.8,303.6,201.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M303.6,208.2c0,0,5.5-8.1,14.5-6.9c9,1.2,12.6,8.7,13.9,12.1c0.7,2.5,1.6,5.9,1.6,5.9l6.9,1.9l0.4,7.8   l-8.9,0.4C332.1,229.3,326.7,198.1,303.6,208.2z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "380.8,228 341,229 340.6,221.2 381.3,220.7  "
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "309.5,170.3 322.9,165.9 323.3,181.4 308.2,183.5  "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M335.8,181.9l-4.4-19.5c0,0,6.5,2.7,9.1,3.1c2.6,0.4,25.9,4.7,25.9,4.7l0.8,15.3c0,0-3.7-1.2-6.2-1.6   S335.8,181.9,335.8,181.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M346.9,150.9l-0.6,6c-8.2-2.3-28.1-6.1-46.2,4.2v-24.8L346.9,150.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M350.1,148.3v9.8c0,0-1.4-0.5-3.8-1.2l0.6-6L300,136.4v-3.9L350.1,148.3z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "258.6,224.4 288.8,220.7 289.4,230.5 259.7,231.7  "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M216.4,221.3l77.9-9.1l-0.4-83.5h-5.1v79c0,0-64.7,7.7-67.8,8.1C217.9,216,216.4,221.3,216.4,221.3z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "295.9,100.5 297.2,104.6 301.5,104.6 298,107.1 299.3,111.2 295.9,108.7 292.4,111.2 293.7,107.1     290.2,104.6 294.5,104.6   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "318.4,103.4 318.7,107.7 322.9,108.7 318.9,110.3 319.1,114.6 316.4,111.3 312.4,112.9 314.7,109.2     312,105.9 316.1,107   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "339.6,111.8 338.8,116 342.5,118.1 338.3,118.6 337.5,122.8 335.6,118.9 331.4,119.5 334.5,116.5     332.7,112.6 336.4,114.7   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "358,125.2 356.1,129 359.2,132 355,131.4 353.1,135.3 352.3,131.1 348.1,130.6 351.9,128.5     351.1,124.3 354.2,127.2   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "273.3,103.4 273,107.7 268.9,108.7 272.9,110.3 272.6,114.6 275.3,111.3 279.3,112.9 277,109.2     279.8,105.9 275.6,107   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "252.2,111.8 253,116 249.2,118.1 253.5,118.6 254.3,122.8 256.1,118.9 260.4,119.5 257.2,116.5     259.1,112.6 255.3,114.7   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "233.8,125.2 235.6,129 232.5,132 236.8,131.4 238.6,135.3 239.4,131.1 243.6,130.6 239.9,128.5     240.7,124.3 237.5,127.2   "
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_8_",
    points: "283.5,134.3 283.5,204.4 220.4,212.6 220.4,158    "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_8_",
    style: {
      overflow: "visible"
    }
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st27"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 211.9,
    y: 144.4,
    transform: "matrix(0.933 -0.3599 0.3599 0.933 -35.9068 101.0047)",
    className: "st28",
    width: 82.6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 211.9,
    y: 149.8,
    transform: "matrix(0.933 -0.3599 0.3599 0.933 -37.8371 101.3641)",
    className: "st29",
    width: 82.6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 211.9,
    y: 155.1,
    transform: "matrix(0.933 -0.3599 0.3599 0.933 -39.7674 101.7236)",
    className: "st30",
    width: 82.6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 211.9,
    y: 160.5,
    transform: "matrix(0.933 -0.3599 0.3599 0.933 -41.6976 102.083)",
    className: "st31",
    width: 82.6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 211.9,
    y: 165.9,
    transform: "matrix(0.933 -0.3599 0.3599 0.933 -43.6279 102.4425)",
    className: "st32",
    width: 82.6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 211.9,
    y: 171.2,
    transform: "matrix(0.933 -0.3599 0.3599 0.933 -45.5582 102.8019)",
    className: "st33",
    width: 82.6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 211.9,
    y: 176.6,
    transform: "matrix(0.933 -0.3599 0.3599 0.933 -47.4885 103.1614)",
    className: "st34",
    width: 82.6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 211.9,
    y: 182,
    transform: "matrix(0.933 -0.3599 0.3599 0.933 -49.4188 103.5208)",
    className: "st35",
    width: 82.6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 211.9,
    y: 187.3,
    transform: "matrix(0.933 -0.3599 0.3599 0.933 -51.3491 103.8803)",
    className: "st36",
    width: 82.6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 211.9,
    y: 192.7,
    transform: "matrix(0.933 -0.3599 0.3599 0.933 -53.2794 104.2397)",
    className: "st37",
    width: 82.6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 211.9,
    y: 198,
    transform: "matrix(0.933 -0.3599 0.3599 0.933 -55.2097 104.5992)",
    className: "st38",
    width: 82.6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 211.9,
    y: 203.4,
    transform: "matrix(0.933 -0.3599 0.3599 0.933 -57.14 104.9586)",
    className: "st39",
    width: 82.6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 211.9,
    y: 208.8,
    transform: "matrix(0.933 -0.3599 0.3599 0.933 -59.0703 105.3181)",
    className: "st40",
    width: 82.6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 211.9,
    y: 214.1,
    transform: "matrix(0.933 -0.3599 0.3599 0.933 -61.0005 105.6775)",
    className: "st41",
    width: 82.6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "218.6,234.1 213.8,234.5 290.9,204.8 295.7,204.4     "
  }))))), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "262.6,139.1 262.6,162.1 237.3,171.8 237.3,145.9  "
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "259.5,187.6 249.7,182.7 239.9,189.5 239.9,170.8 259.5,163.3   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "257.6,181.1 241.8,181.1 241.8,149.9 257.6,144   "
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M221.7,247.2h-5.3c0,0-6.3-9-7.5-12.7c5.8-4.1,7.5,0.4,7.5,0.4l6.9,9.7L221.7,247.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M378.7,242.1c0,0-2.1,3.4-3.4,5.1c-3.2,0-5.3,0-5.3,0l-0.2-0.5c0,0,1.1-2.8,1.4-3.3c0.2-0.5,1.7-1.7,2-1.9   c0.3-0.2,0.5-0.4,1.1-0.5c0.6,0,2.6,0.2,2.6,0.2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M206.1,166.5l-0.6,46.9c0,0-2.9-10.7-2.7-23.9C203,176.4,206.1,166.5,206.1,166.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostmericaLogo);
export default __webpack_public_path__ + "static/media/postmericaLogo.140bc1731f4923206949c63f19a38f21.svg";
export { ForwardRef as ReactComponent };